import { Controller } from "@hotwired/stimulus"

// Toggles a mobile off-canvas sidebar with backdrop overlay.
// Usage:
//   <div data-controller="sidebar">
//     <button data-action="sidebar#open">☰</button>
//     <div data-sidebar-target="backdrop" data-action="click->sidebar#close" class="hidden ..."></div>
//     <nav data-sidebar-target="panel" class="-translate-x-full ...">...</nav>
//   </div>
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  open() {
    this.panelTarget.classList.remove("-translate-x-full")
    this.backdropTarget.classList.remove("hidden")
  }

  close() {
    this.panelTarget.classList.add("-translate-x-full")
    this.backdropTarget.classList.add("hidden")
  }
}
